export default "__VITE_ASSET__BURi9Zpj__"